import { ModalCopyRequestMessage } from './../types/modal-copy-request';
import { ModalPasteRequestMessage } from './../types/modal-paste-request';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMessagerService } from './modal-messager.service';
import { ModalConfirmMsg } from '../types/modalconfirmmsg';
import { ModalMessage } from '../types/modalmessage';
import { ModalProgMsg } from '../types/modalprogmsg';
import { ModalNotice } from '../types/modalnotice';
import * as $ from 'jquery';
import { InterruptableTimer } from '../model/interruptabletimer';
import { SimpleHandler, DictHandler } from '../types/@types/sl-v-types';

import { Dict } from 'src/app/types/decorable';
import { SubScriptionMgr } from '../model/SubscriptionMgr';
import { StatefulCSS } from '../model/stateful_css';
import { ModalCompressedFileRequestMessage, ModalFileRequestMessage } from '../types/modalfilerequestmessage';
import { ModaLRemoteCtrlMessage } from '../types/modall-remote-ctrl-message';
import { ModalFileDownloadRequestMessage } from '../types/modal-file-download-request';
import { SlWapiService } from '../model/api-services/sl-wapi.service';

import * as JSZip from 'jszip';
import sanitize from 'sanitize-filename';
enum ModalMessagerMode {
  UNKNOWN = '',
  CONFIRM = 'confirm',
  NOTIFY = 'notify',
  PROGRESS = 'progress',
  REQ_IMPORT = 'request-import',
  REQ_EXPORT = 'request-export',
  REQ_COMPRESSED_EXPORT = 'request-compressed-export',
  REQ_DOWNLOAD = 'request-download',
  REQ_PASTE = 'request-paste',
  REQ_COPY = 'request-copy'
}
export type MessageOption = {
  label: string;
  name: string;
}
@Component({
  selector: 'app-modal-messager-content',
  templateUrl: './modal-messager.component.html',
  styleUrls: ['./modal-messager.component.scss'],
  // tslint:disable-next-line: no-host-metadata-property
  host: { class: 'work-view no-back no-subtitle with-type-icon' }
})
export class ModalMessagerContentComponent implements OnInit {
  private modalMessage: ModalMessage;
  private timer: InterruptableTimer;
  private displayMode: ModalMessagerMode;
  private states: StatefulCSS;
  private isReusing = false;
  public fileExt = '.txt';
  public fileName = '';
  public fileAccept = '.txt';
  public file: any = null;
  public messageOptions: Array<MessageOption> = [];
  public pastedData: string = '';
  public copyData: string = '';

  private zipProgress = -1;

  @ViewChild('modalTitle', { static: true }) modalTitle: ElementRef;
  @ViewChild('message', { static: true }) message: ElementRef;
  @ViewChild('barData', { static: true }) barData: ElementRef;
  @ViewChild('progressBar', { static: true }) progressBar: ElementRef;
  @ViewChild('buttonOne', { static: true }) buttonOne: ElementRef;
  @ViewChild('buttonTwo', { static: true }) buttonTwo: ElementRef;
  @ViewChild('requestExportUI', { static: true }) requestExportUI: ElementRef;
  @ViewChild('requestImportUI', { static: true }) requestImportUI: ElementRef;
  @ViewChild('downloadAnchor', { static: true }) downloadAnchor: ElementRef;
  @ViewChild('importFileName', { static: true }) importFileName: ElementRef;
  @ViewChild('exportFileName', { static: true }) exportFileName: ElementRef;
  @ViewChild('requestPasteUI', { static: true }) requestPasteUI: ElementRef;
  @ViewChild('copyContentArea', { static: true }) copyContentArea: ElementRef<HTMLTextAreaElement>;

  constructor(private domNode: ElementRef, private wapi: SlWapiService, public modal: NgbActiveModal) {
    this.timer = new InterruptableTimer();
    this.states = new StatefulCSS(
      ['info', 'progress', 'progress-done', 'warn', 'confirm', 'request-export', 'request-compressed-export', 'request-import', 'request-paste', 'request-copy'],
      this.domNode.nativeElement,
      'modal-mode');
    this.states.SetState('info');
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'escape') {
      switch (this.states.GetCurrentState()) {
        case 'request-import':
        case 'request-export':
        case 'request-compressed-export':
        case 'request-download':
          this.HandleCancel();
          break;
        case 'info':
          this.HandleOK();
          break;
        case 'progress':
          if ((this.modalMessage as ModalProgMsg).progress >= 1) {
            this.HandleOK();
            return;
          }
          if ((this.modalMessage as ModalProgMsg).cancelable) {
            this.HandleCancel('escaped');
          }
          break;
        case 'progress-done':
          this.HandleOK();
          return;
        case 'warn':
          this.HandleOK();
          break;
        case 'confirm':
          this.HandleButtonTwoClick();
          // this.HandleCancel('escaped');
          break;
      }
    }
  }
  Ok(title: string) {
    if (this.modalTitle.nativeElement.innerHTML === title) {
      this.HandleOK();
    }
  }
  Cancel(title: string, reason?: string) {
    if (this.modalTitle.nativeElement.innerHTML === title) {
      this.HandleCancel(reason);
    }
  }
  ngOnInit() {
    this.isReusing = this.isReusing;
    $(this.domNode.nativeElement).on('click', () => {
      this.ModalClicked();
    });
    $(this.buttonOne.nativeElement).on('click', () => { this.HandleButtonOneClick(); });
    $(this.buttonTwo.nativeElement).on('click', () => { this.HandleButtonTwoClick(); });


  }

  SetTitle(title: string = '') {
    this.modalTitle.nativeElement.innerHTML = title;
    $(this.modalTitle.nativeElement).toggleClass('hidden', title === '');

  }

  Confirm(message: ModalConfirmMsg) {
    this.states.SetState('confirm');
    this.messageOptions = message.options ? message.options : [];

    $(this.domNode.nativeElement).toggleClass('modal-warning', false);
    this.displayMode = ModalMessagerMode.CONFIRM;
    this.SetTitle(message.title);
    $(this.buttonOne.nativeElement).toggleClass('hidden', this.messageOptions.length > 0);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);
    $(this.barData.nativeElement).toggleClass('hidden', true);

    this.buttonOne.nativeElement.innerHTML = 'Ok';
    this.buttonTwo.nativeElement.innerHTML = 'Cancel';

    this.message.nativeElement.innerHTML = message.message;

    this.modalMessage = message;
  }
  Notify(message: ModalNotice) {
    this.states.SetState('info');
    this.modalMessage = message;
    this.displayMode = ModalMessagerMode.NOTIFY;
    this.SetTitle(message.title);
    $(this.domNode).toggleClass('modal-warning', message.asWarning);
    if (message.asWarning) {
      this.states.SetState('warn');
    }
    this.buttonOne.nativeElement.value = 'Close';
    this.message.nativeElement.innerHTML = message.message;
    let timeDelay = 1000;
    if ((message.message.length) / 0.015 > timeDelay) {
      timeDelay = (message.message.length) / 0.015;
    }
    this.HideProgress();
    if (!message.asWarning) {
      this.timer.Start(this.HideModal.bind(this), timeDelay);
    }
  }
  HideProgress(): void {
    $(this.progressBar.nativeElement).toggleClass('hidden', true);
    $(this.barData.nativeElement).toggleClass('hidden', true);

  }
  UnHideProgress(): void {
    $(this.progressBar.nativeElement).toggleClass('hidden', false);
    $(this.barData.nativeElement).toggleClass('hidden', false);
  }
  Progress(message: ModalProgMsg): void {

    this.displayMode = ModalMessagerMode.PROGRESS;
    $(this.domNode.nativeElement).toggleClass('modal-warning', false);
    this.UnHideProgress();

    this.SetTitle(message.title);

    if (message.cancelable) {
      this.buttonOne.nativeElement.innerHTML = message.progress === 1 ? 'Close' : 'Cancel';
      $(this.buttonOne.nativeElement).toggleClass('hidden', false);
      $(this.buttonTwo.nativeElement).toggleClass('hidden', true);
    } else {
      message.cancelHandler = null;
      this.buttonOne.nativeElement.innerHTML = 'Ok';
      $(this.buttonOne.nativeElement).toggleClass('hidden', message.progress < 1);
      $(this.buttonTwo.nativeElement).toggleClass('hidden', true);
    }
    this.message.nativeElement.innerHTML = message.message;
    this.progressBar.nativeElement.style.width = '0%;';
    this.progressBar.nativeElement.innerHTML = '';

    this.modalMessage = message;

    if (!isNaN(message.progress)) {
      if (message.progress < 0) {
        message.progress = 0;
      }
      if (message.progress > 1) {
        message.progress = 1;
      }

      const percent = Math.floor(message.progress * 100.0);
      const newProgress = 'w-' + percent;
      $(this.barData.nativeElement).toggleClass('hidden', false);
      $(this.progressBar.nativeElement).toggleClass(newProgress, true);
      this.progressBar.nativeElement.style.width = percent + '%';
      this.progressBar.nativeElement.innerHTML = percent + '%';
      if (percent === 100.0) {
        this.states.SetState('progress-done');
        $(this.progressBar.nativeElement).toggleClass('progress-bar-striped', false);
        $(this.progressBar.nativeElement).toggleClass('progress-bar-animated', false);
        let timeDelay = 2500;
        if ((message.message.length) / 0.015 > 2500) {
          timeDelay = (message.message.length) / 0.015;
        }
        if (!this.timer.wasRunning) {
          this.timer.Start(() => { this.HideModal(); }, timeDelay);
        }


      } else {
        this.states.SetState('progress');
        $(this.progressBar.nativeElement).toggleClass('progress-bar-striped', true);
        $(this.progressBar.nativeElement).toggleClass('progress-bar-animated', true);
        // $(this.buttonOne.nativeElement).toggleClass('hidden', true);
        // $(this.buttonTwo.nativeElement).toggleClass('hidden', true);
      }
    }
    this.isReusing = true;
  }
  RequestImport(message: ModalFileRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_IMPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    $(this.buttonOne.nativeElement).toggleClass('hidden', true);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);

  }
  HandleFile(event: any) {
    if (!!event.target.files) {
      this.file = event.target.files[0];
    }
  }
  HandleImport() {
    const reader = new FileReader();
    reader.onload = (e) => {
      const contents = e.target.result;
      if (!!(this.modalMessage as ModalFileRequestMessage).okHandler) {
        (this.modalMessage as ModalFileRequestMessage).okHandler({ file: this.file, contents: (contents) });
      }
      this.HideProgress();
      this.modal.close();

    };
    reader.onerror = (e) => {
      e = null;
      this.HideProgress();
      if (!!(this.modalMessage as ModalFileRequestMessage).cancelHandler) {
        (this.modalMessage as ModalFileRequestMessage).cancelHandler({ reason: 'error', error: reader.error });
      }
    }
    reader.onabort = (e) => {
      e = null;
      this.HideProgress();
      if (!!(this.modalMessage as ModalFileRequestMessage).cancelHandler) {
        (this.modalMessage as ModalFileRequestMessage).cancelHandler({ reason: 'aborted' });
      }
    }
    reader.onloadstart = () => {
      this.progressBar.nativeElement.style.width = '0%;';
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : 0%';
      this.UnHideProgress();
      // show progress bar
    }
    reader.onprogress = (event) => {

      const percent = this.file.size / event.loaded;
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : ' + percent + '%';
      this.UnHideProgress();
      // show progress amount
    }
    reader.onloadend = () => {
      const percent = 100;
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : ' + percent + '%';
    }
    let readType = (this.modalMessage as ModalFileRequestMessage).readType;
    const encoding = (this.modalMessage as ModalFileRequestMessage).encoding;
    if (!readType) {
      readType = 'text';
    }
    switch (readType) {
      case 'buffer':
        reader.readAsArrayBuffer(this.file);
        break;
      case 'string':
        reader.readAsBinaryString(this.file);
        break;
      case 'dataURL':
        reader.readAsArrayBuffer(this.file);
        break;
      case 'text':
        if (!!encoding) {
          reader.readAsText(this.file, encoding);
        } else {
          reader.readAsText(this.file);
        }
        break;
    }
  }
  RequestCompressedExport(message: ModalFileRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_COMPRESSED_EXPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message?.title);
    this.message.nativeElement.innerHTML = message?.message;
    const zipper = new JSZip();
    let start = 0;
    const maxFiles = Object.values(message.contents).length;
    this.fileExt = 'zip';
    for (const file in message.contents) {
      const fileInfo = message.contents[file];
      if (!fileInfo || !fileInfo.extension) continue;
      start += 1;

      this.message.nativeElement.innerHTML = message.message;
      const fileNum = start + 1;
      this.progressBar.nativeElement.style.width = (fileNum / maxFiles) + '%';
      this.progressBar.nativeElement.innerHTML = `Adding File ${fileNum} of ${maxFiles}`;
      let contents = fileInfo.contents;
      const zipParams: JSZip.JSZipFileOptions = {};
      if (fileInfo.mimeType === ' ') {
        const commaIndex = contents.indexOf(',');
        if (commaIndex > -1) {
          contents = (contents as string).substring(contents.indexOf(',') + 1);
        }
        zipParams.base64 = true;
      }
      let ext = fileInfo.extension;
      if (ext?.substring(0, 1) === '.') ext = ext.substring(1);
      zipper.file(sanitize(message.contents.defaultFileName) + '.' + ext, contents, zipParams);
    }
    this.fileAccept = '.zip';
    $(this.buttonOne.nativeElement).toggleClass('hidden', true);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);
    this.exportFileName.nativeElement.value = (!!message.contents.defaultFileName) ? message.contents.defaultFileName : 'New File';

    this.progressBar.nativeElement.innerHTML = `Generating zip file`;
    this.fileExt = '.zip';
    let isDataURL = false;
    zipper.generateAsync({ type: 'blob' }).then((content) => {
      this.HideProgress();
      this.downloadAnchor.nativeElement.href = this.MakeDataURL('application/zip', content)
      this.UpdateDownloadAnchor();

    })
  }

  RequestExport(message: ModalFileRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_EXPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    $(this.buttonOne.nativeElement).toggleClass('hidden', true);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);
    this.exportFileName.nativeElement.value = (!!message.defaultFileName) ? message.defaultFileName : 'New File';
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileExt = (!!message.acceptedExts) ? message.acceptedExts[0] : '.txt';
    let isDataURL = false;
    if (typeof message.contents === 'string') {
      if (message.contents.substring(0, 4) === 'data') isDataURL = true;
    }
    this.downloadAnchor.nativeElement.href = isDataURL ? message.contents : this.MakeDataURL(message.encoding, message.contents)
    this.UpdateDownloadAnchor();
  }

  RequestDownload(message: ModalFileDownloadRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_EXPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    this.exportFileName.nativeElement.value = (!!message.defaultFileName) ? message.defaultFileName : 'New File';
    $(this.buttonOne.nativeElement).toggleClass('hidden', true);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileExt = (!!message.acceptedExts) ? message.acceptedExts[0] : '.txt';
    $(this.downloadAnchor.nativeElement).toggleClass('disabled', true);
    this.wapi.DownloadFile(message.wapiURL, message.params, message.mimeType, message.defaultFileName, (response) => {
      this.downloadAnchor.nativeElement.href = response.url;
      $(this.downloadAnchor.nativeElement).toggleClass('disabled', false);
    });
    this.UpdateDownloadAnchor();


  }
  RequestPaste(message: ModalPasteRequestMessage) {
    $(this.buttonOne.nativeElement).toggleClass('hidden', false);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', false);
    this.displayMode = ModalMessagerMode.REQ_PASTE;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;

  }
  RequestCopy(message: ModalCopyRequestMessage) {
    $(this.buttonOne.nativeElement).toggleClass('hidden', false);
    $(this.buttonTwo.nativeElement).toggleClass('hidden', true);
    this.displayMode = ModalMessagerMode.REQ_COPY;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    this.copyData = message.content
    setTimeout(() => {
      this.copyContentArea.nativeElement.focus();
      this.copyContentArea?.nativeElement.select();
    }, 1000)
  }

  MakeDataURL(mimeType: string, payload: any) {
    if (payload instanceof Blob) {
      return window.URL.createObjectURL(payload);
    }
    if (typeof payload === 'string') {
      if (payload.indexOf('data:' + mimeType + ';') === 0) return payload;
    }
    if (typeof payload !== 'string') {
      if (mimeType === 'application/json') {
        payload = JSON.stringify(payload);
        if (!payload) {
          // problem
          return;
        }
      }
    }
    const blob1 = new Blob([payload], { type: mimeType });

    const url = window.URL.createObjectURL(blob1);
    return url;
  }
  UpdateFileName() {
    this.UpdateDownloadAnchor();
  }
  UpdateDownloadAnchor() {
    this.downloadAnchor.nativeElement.setAttribute('download', this.exportFileName.nativeElement.value + this.fileExt);
  }
  SanitizeExts(exts: Array<string>) {
    for (let i = 0, l = exts.length; i < l; i++) {
      if (exts[i][0] !== '.') {
        exts[i] = '.' + exts[i];
      }
    }
  }
  HandleMessageOption(messageOption: MessageOption) {
    const okHandler: DictHandler | null = (this.modalMessage as ModalConfirmMsg).okHandler as DictHandler;
    if ([undefined, null].indexOf(okHandler) < 0) {
      okHandler({ option: messageOption });
    }
    this.HideModal('complete');
  }
  HandleOK(okHandler: SimpleHandler | DictHandler | null = null, optArgs: Dict = null) {
    if (okHandler !== null) {
      okHandler(optArgs);
    }
    this.HideModal('complete');
  }
  HandleCancel(why: string = 'cancelled') {
    this.HideModal(why);
  }

  HideModal(why: string = 'complete') {
    this.displayMode = ModalMessagerMode.UNKNOWN;
    this.timer.Stop();


    $(this.domNode.nativeElement).parentsUntil('ngb-modal-window').prev('ngb-modal-backdrop').toggleClass('hidden', true);
    $(this.domNode.nativeElement).parentsUntil('ngb-modal-window').fadeOut('medium');
    setTimeout(() => {
      if (why === 'complete') {

        this.modal.close();
      } else {
        this.modal.dismiss(why);
      }
    }, 100);
  }
  ModalClicked() {
    this.timer.Stop();
  }
  HandleButtonOneClick() {
    switch (this.displayMode) {
      case ModalMessagerMode.CONFIRM:
      case ModalMessagerMode.NOTIFY:
      case ModalMessagerMode.PROGRESS:
      case ModalMessagerMode.REQ_EXPORT:
      case ModalMessagerMode.REQ_IMPORT:
      case ModalMessagerMode.REQ_COPY:
        {
          const okHandler: SimpleHandler | null = (this.modalMessage as ModalConfirmMsg).okHandler as SimpleHandler;
          try {
            if ([undefined, null].indexOf(okHandler) < 0) {
              okHandler();
            }
          } finally {
            this.HideModal('complete');
          }
        }
        break;
      case ModalMessagerMode.REQ_PASTE:
        {
          const okHandler: DictHandler | null = (this.modalMessage as ModalConfirmMsg).okHandler as DictHandler;
          try {
            if ([undefined, null].indexOf(okHandler) < 0) {
              okHandler({ content: this.pastedData });
            }
          } finally {
            this.HideModal('complete');
          }
        }

    }
  }
  HandleButtonTwoClick() {
    let errHandler: DictHandler | null = null;
    switch (this.displayMode) {
      case ModalMessagerMode.CONFIRM:
        errHandler = (this.modalMessage as ModalConfirmMsg).cancelHandler as DictHandler;
        break;
      case ModalMessagerMode.NOTIFY:
      case ModalMessagerMode.PROGRESS:
        errHandler = (this.modalMessage as ModalProgMsg).cancelHandler as DictHandler;
        break;
      case ModalMessagerMode.UNKNOWN:


    }
    if ([undefined, null].indexOf(errHandler) < 0) {
      errHandler({ reason: 'cancelled' });
    }
    this.HideModal('cancel');
  }
  ExportClicked(e) {
    const message: ModalFileRequestMessage = this.modalMessage as ModalFileRequestMessage;
    if (message.okHandler) {
      message.okHandler(message);
    }
    this.modal.close();
    return true;
  }

}

@Component({
  selector: 'app-modal-messager',
  template: ''
})
export class ModalMessagerComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr;
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private messagerService: ModalMessagerService) {

    this.subscriptionMgr = new SubScriptionMgr();
    this.subscriptionMgr.Subscribe(messagerService.remoteCtrl$, (message: ModaLRemoteCtrlMessage) => {
      if (!!this.modalRef) {
        if (!!this.modalRef.componentInstance) {
          switch (message.cmd) {
            case 'ok':
              this.modalRef.componentInstance.Ok(message.title);
              break;
            case 'cancel':
              this.modalRef.componentInstance.Cancel(message.title, message.message);
          }

        }
      }
    });
    this.subscriptionMgr.Subscribe(messagerService.confirm$, (message: ModalConfirmMsg) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.Confirm(message);
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.notify$, (message: ModalNotice) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.Notify(message);
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.cancellation$, (message: any) => {
      if (this.lastTitle === message.title) {
        this.modalRef.componentInstance.HandleCancel();
        this.lastTitle = null;
      }
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.progress$, (message: ModalProgMsg) => {
      if ((this.lastTitle === message.title) && this.lastTitle != null) {
        if (this.modalRef === null) {
          return;
        }
        try {
          this.modalRef.componentInstance.Progress(message);
          if (message.progress >= 1) {
            this.lastTitle = null;
          }
          return;
        } catch (e) {
          this.modalRef = null;
          this.lastTitle = null;
          this.messagerService.CancelProgress(message.title);

        }
        return;
      }
      this.lastTitle = message.title;

      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.Progress(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.importRequest$, (message: ModalFileRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestImport(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.compressedExportRequest$, (message: ModalCompressedFileRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestCompressedExport(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.exportRequest$, (message: ModalFileRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestExport(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.downloadRequest$, (message: ModalFileDownloadRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestDownload(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.pasteRequest$, (message: ModalPasteRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestPaste(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.copyRequest$, (message: ModalCopyRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static' });
      this.modalRef.componentInstance.RequestCopy(message);
    });
  }

  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
    delete this.subscriptionMgr;
  }


}
